import { cssConstants } from '../constants'
import { ScreenSize } from './use-view'

export const ScreenQuery = {
  /*
   * space is added to the start and end of the string to prevent accidental concatenation,
   * which may break css rules
   */
  [ScreenSize.desktop]: ` @media (min-width: ${cssConstants.desktopWidthBreakPoint}px) `,
  [ScreenSize.tablet]: ` @media (min-width: ${
    cssConstants.tabletWidthBreakPoint
  }px) and (max-width: ${cssConstants.desktopWidthBreakPoint - 1}px) `,
  [ScreenSize.mobile]: ` @media (max-width: ${
    cssConstants.tabletWidthBreakPoint - 1
  }px) `,
}
